import InputCurrency from './InputCurrency';

export * from './InputCurrency';
export default InputCurrency;
